import { z } from '@repo/schema'

import { GetCompanyAddressSchema, GetCompanySchema } from './company'
import { PaymentTermPeriodSchema, PaymentTermTriggerSchema } from './payment-terms'
import { GetUserSchema } from './user'

export const InvoiceSettingsPayloadSchema = z.object({
  days: z.number().int().min(1).max(365).nullish(),
  period: PaymentTermPeriodSchema.nullish(),
  trigger: PaymentTermTriggerSchema,
})

export const CreateCustomerRiskProfileBodySchema = z.object({
  credit_limit: z.number().int().min(0),
  invoice_settings: InvoiceSettingsPayloadSchema,
  notes: z.string().trim().min(1),
  score: z.string().min(1),
  setup_form_id: z.number().int().positive(),
  valid_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Please enter a valid date'),
})

export const CreateCompanyCustomerRiskProfileBodySchema = z.object({
  credit_limit: z.number().int().min(0),
  invoice_settings: InvoiceSettingsPayloadSchema,
  notes: z.string().trim().min(1),
  score: z.string().min(1),
  valid_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Please enter a valid date'),
})
export const GetCustomerRiskProfileDefaultCurrencySchema = z.object({
  alias: z.string().transform(value => value.toUpperCase()),
  symbol: z.string(),
  title: z.string(),
})
export const GetCustomerRiskProfileCompanySchema = GetCompanySchema.extend({
  address: GetCompanyAddressSchema.extend({
    lat: z.number().nullish(),
    lng: z.number().nullish(),
  }).nullish(),
  address_distance: z.number().nullish(),
  default_currency: GetCustomerRiskProfileDefaultCurrencySchema.nullish(),
  destination_distance: z.number().nullish(),
  last_edit: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullish(),
  origin_distance: z.number().nullish(),
  short_title: z.string().nullish(),
  suspended_at: z.coerce.date().nullish(),
  suspended_to: z.coerce.date().nullish(),
  updated_at: z.coerce.date(),
  verified_at: z.coerce.date().nullish(),
})
const GetCustomerRiskProfileVerifiedByUserSchema = GetUserSchema.extend({
  source: z.string().nullish(),
})
export const GetCustomerRiskProfileSchema = z.object({
  company_id: z.number(),
  created_at: z.coerce.date(),
  credit_limit: z.number().int().min(0).nullish(),
  id: z.number(),
  invoice_settings: z.string().nullish(),
  notes: z.string(),
  score: z.string(),
  updated_at: z.coerce.date(),
  valid_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  verified_by: z.number().nullish(),
  verified_by_user: GetCustomerRiskProfileVerifiedByUserSchema.nullish(),
})
export type CreateCompanyCustomerRiskProfileBody = z.infer<
  typeof CreateCompanyCustomerRiskProfileBodySchema
>
export type CreateCustomerRiskProfileBody = z.infer<typeof CreateCustomerRiskProfileBodySchema>
export type GetCustomerRiskProfile = z.infer<typeof GetCustomerRiskProfileSchema>
